var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _vm.topicText
      ? _c(
          "div",
          {
            staticClass: "col-1 d-flex align-items-center",
            class: _vm.topicTextClass
          },
          [_vm._v(" " + _vm._s(_vm.topicText) + " ")]
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "row font-weight-bold color-black font-12",
        class: _vm.topicText ? "col-11" : "col-12"
      },
      _vm._l(_vm.historialItems, function(item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "cube col-1 px-0",
            class: _vm.classObject({ item, index })
          },
          [
            _c("div", { staticClass: "col-12 text-center pt-2 header" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(item.title))
              ]),
              _c("div", { staticClass: "col-12" }, [
                _vm._v(_vm._s(item.subtitle))
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "checkbox-container col-12 text-center",
                class: _vm.checkboxContainerClass
              },
              [
                !item.readonly
                  ? _c("input", {
                      staticClass: "mt-2",
                      attrs: {
                        id: `accordion-cb-${index}`,
                        disabled: item.isDisabled || item.isBlocked,
                        name: "accordion-cb",
                        type: "radio"
                      },
                      domProps: { checked: item.isChecked, value: item },
                      on: {
                        input: function($event) {
                          return _vm.emitValue(item)
                        }
                      }
                    })
                  : _vm._e(),
                item.readonly && item.isChecked
                  ? _c("i", {
                      staticClass:
                        "fa fa-check-circle fa-lg mt-2 pt-1 icon-readonly",
                      attrs: { "aria-hidden": "true" }
                    })
                  : _vm._e(),
                item.readonly && !item.isChecked
                  ? _c("i", {
                      staticClass:
                        "far fa-circle fa-lg mt-2 pt-1 icon-readonly",
                      attrs: { "aria-hidden": "true" }
                    })
                  : _vm._e()
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }